/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { PayRunStatus } from "./PayRunStatus";
import {
  PayRunStatusFromJSON,
  PayRunStatusFromJSONTyped,
  PayRunStatusToJSON,
  PayRunStatusToJSONTyped,
} from "./PayRunStatus";

/**
 *
 * @export
 * @interface PayRunSummary
 */
export interface PayRunSummary {
  /**
   *
   * @type {string}
   * @memberof PayRunSummary
   */
  payRunId: string;
  /**
   *
   * @type {LocalDate}
   * @memberof PayRunSummary
   */
  periodStart: LocalDate;
  /**
   *
   * @type {LocalDate}
   * @memberof PayRunSummary
   */
  periodEnd: LocalDate;
  /**
   *
   * @type {PayRunStatus}
   * @memberof PayRunSummary
   */
  status: PayRunStatus;
  /**
   *
   * @type {string}
   * @memberof PayRunSummary
   */
  createdByEmail: string;
}

/**
 * Check if a given object implements the PayRunSummary interface.
 */
export function instanceOfPayRunSummary(value: object): value is PayRunSummary {
  if (!("payRunId" in value) || value["payRunId"] === undefined) return false;
  if (!("periodStart" in value) || value["periodStart"] === undefined)
    return false;
  if (!("periodEnd" in value) || value["periodEnd"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("createdByEmail" in value) || value["createdByEmail"] === undefined)
    return false;
  return true;
}

export function PayRunSummaryFromJSON(json: any): PayRunSummary {
  return PayRunSummaryFromJSONTyped(json, false);
}

export function PayRunSummaryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PayRunSummary {
  if (json == null) {
    return json;
  }
  return {
    payRunId: json["payRunId"],
    periodStart: json["periodStart"],
    periodEnd: json["periodEnd"],
    status: PayRunStatusFromJSON(json["status"]),
    createdByEmail: json["createdByEmail"],
  };
}

export function PayRunSummaryToJSON(json: any): PayRunSummary {
  return PayRunSummaryToJSONTyped(json, false);
}

export function PayRunSummaryToJSONTyped(
  value?: PayRunSummary | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    payRunId: value["payRunId"],
    periodStart: value["periodStart"],
    periodEnd: value["periodEnd"],
    status: PayRunStatusToJSON(value["status"]),
    createdByEmail: value["createdByEmail"],
  };
}
